import { render, staticRenderFns } from "./BaseFormGroup.vue?vue&type=template&id=dbc534b4&scoped=true"
import script from "./BaseFormGroup.vue?vue&type=script&lang=js"
export * from "./BaseFormGroup.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroup.vue?vue&type=style&index=0&id=dbc534b4&prod&lang=scss&scoped=true"
import style1 from "./BaseFormGroup.vue?vue&type=style&index=1&id=dbc534b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc534b4",
  null
  
)

export default component.exports